import React from 'react';

// A chart's side of a Composite's legend link (see compositeLegend), for
// charts drawn without Highcharts. The block's Numbers stand in for the
// chart's legend: they take their series' colours, and hovering either
// highlights the other.
export interface ChartLegendLink {
  // The metrics the chart shares with the block's Numbers
  linkedMetricIds: string[];
  // The metric a hovered Number (or series) is highlighting
  highlightedMetricId: string | undefined;
  // The pointer entered (a metric) or left (undefined) a linked series
  onHover: (metricId: string | undefined) => void;
  // What each metric's series is drawn in, for its Number
  reportColors: (colors: Record<string, string>) => void;
}

const ChartLegendLinkContext = React.createContext<ChartLegendLink | undefined>(
  undefined,
);

export default ChartLegendLinkContext;
